<template>
  <Modal
    :isOpen="!!component"
    :title="title"
    @onClose="handleModalClose"
    :closeOnOutsideClick="closeOnOutsideClick"
  >
    <component :is="component" @onClose="handleClose" v-bind="props" />
  </Modal>
</template>

<script>
import { ModalBus } from "@/eventBus.js";
import Modal from "./Modal.vue";
export default {
  data() {
    return {
      component: null,
      title: "",
      props: null,
      closeOnClick: true,
      closeOnOutsideClick: true
    };
  },
  created() {
    ModalBus.$on(
      "open",
      ({
        component,
        title = "",
        props = null,
        closeOnClick = true,
        closeOnOutsideClick
      }) => {
        this.component = component;
        this.title = title;
        this.props = props;
        this.closeOnClick = closeOnClick;
        this.closeOnOutsideClick = closeOnOutsideClick;
      }
    );
    document.addEventListener("keyup", this.handleKeyup);
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.handleKeyup);
  },
  methods: {
    handleModalClose(force = false) {
      if (!this.closeOnClick && !force) return;
      this.handleClose();
    },
    handleClose() {
      this.component = null;
    },
    handleKeyup(e) {
      if (e.keyCode === 27) this.handleClose();
    }
  },
  components: { Modal }
};
</script>
